import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { api } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class NotificaService {
  constructor(
    private rest: RestService,
    private route: Router,
    private http: HttpClient
  ) {}

  createNotification(
    title: string,
    description: string,
    link: string,
    destination: number,
    scheduledAt?:any
  ) {
    return this.rest.post(`${api.endpoint.createNotificacion}`, {
      titolo: title,
      descrizione: description,
      link,
      destinatari: destination,
      scheduledAt:scheduledAt
    });
  }

  editNotification(
    title: string,
    description: string,
    link: string,
    destination: number,
    id: string,
    // scheduledAt?:string
  ) {
    return this.rest.patch(`${api.endpoint.createNotificacion}/${id}`, {
      titolo: title,
      descrizione: description,
      link,
      destinatari: destination,
      // scheduledAt
    });
  }

  deleteNotification(id: string) {
    return this.rest.delete(`${api.endpoint.createNotificacion}/${id}`);
  }

  paginateNotification(search = '', date = '', page = 0) {
    return this.rest.post(`notifica/paginate?page=${page}`, {
      wordKey: search,
      date: date,
    });
  }
}
